<script setup>
defineProps({
  darkMode: Boolean,
  transparent: Boolean,
  padBottom: Boolean
});
</script>

<template>
  <div
    :class="{
      'dark bg-highlight! text-highlight-content': darkMode,
      'mb-4': padBottom
    }"
    class="card bg-foreground flex w-full flex-col rounded p-6 md:p-8"
  >
    <div class="text-lg">
      <slot name="header" />
    </div>
    <div><slot /></div>
    <div><slot name="footer" /></div>
  </div>
</template>
